import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './features/home/home.component';
import { MenuComponent } from './features/menu/menu.component';
import { ProductsComponent } from './features/products/products.component';
import { NewsStoriesComponent } from './features/news-stories/news-stories.component';
import { VisitUsComponent } from './features/visit-us/visit-us.component';
import { OurStoryComponent } from './features/our-story/our-story.component';
import { NewsStoriesDetailComponent } from './features/news-stories-detail/news-stories-detail.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    MenuComponent,
    ProductsComponent,
    NewsStoriesComponent,
    VisitUsComponent,
    OurStoryComponent,
    NewsStoriesDetailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
